import api from "lib/api";
import apiFormData from "lib/apiFormData";

export const expenseManagement = async (params) => {
    return await apiFormData.post("/v1/expense/expenseManagement", params);
};

export const getExpense = async (params) => {
    return await api.post("/v1/expense/getExpense", params);
};

export const getExpenseReportPaging = async (params) => {
    return await api.post("/v1/expense/getExpenseReportPagination", params);
};

export const getTravelReportPaging = async (params) => {
    return await api.post("/v1/expense/getTravelReportPagination", params);
};

export const deleteExpenseById = async (params) => {
    return await api.post("/v1/expense/deleteExpense", params);
};

export const getMyExpense = async (params) => {
    return await api.post("/v1/expense/getMyExpense", params);
};

export const getCompanyExpense = async (params) => {
    return await api.post("/v1/expense/getExpenseList", params);
};

export const getCurrency = async (params = {}) => {
    return await api.post("/v1/dropdown/getCurrency", params);
};

export const paid = async (params = {}) => {
    return await api.post("/v1/expense/paid", params);
};

export const getDropDown = async (params = {}) => {
    return await api.post("/v1/dropdown/getEmployee", params);
};

export const getMyExpenseRequestPagination = async (params = {}) => {
    return await api.post("/v1/expense/getMyExpenseRequestPagination", params);
};
export const getMyExpenseYearSummaryChart = async (params = {}) => {
    return await api.post("/v1/expense/getMyExpenseYearSummaryChart", params);
};
export const getMyExpenseSummaryChart = async (params = {}) => {
    return await api.post("/v1/expense/getMyExpenseSummaryChart", params);
};
export const getMyTxnExpenseById = async (params = {}) => {
    return await api.post("/v1/expense/getTxnExpenseById", params);
};

export const updateTxnExpense = async (params = {}) => {
    return await apiFormData.post("/v1/expense/updateTxnExpense", params);
};
export const createTxnExpense = async (params) => {
    return await apiFormData.post("/v1/expense/createTxnExpense", params);
};
export const getDropdownWelfareSubTypeByCode = async (params = {}) => {
    return await api.post("/v1/dropdown/getWelfareSubTypeByCode", params);
};
export const dropdownProjectByEmployeeId = async (params = {}) => {
    return await api.post("v1/myTimeSheet/dropdownProjectByEmployeeId", params);
};
export const getEmployeeWelfareDropdown = async (params = {}) => {
    return await api.post("v1/employee/getEmployeeWelfareDropdown", params);
};
export const getCommonTypeByCode = async (params = {}) => {
    return await api.post("v1/dropdown/getCommonTypeByGroupType", params);
};


export const getWorkflowByRequestId = async (params) => {
    return await api.post("/v1/leaveRequest/getWorkflowByRequestId", params);
};

export const getGeneralInfomation = async (params = {}) => {
    return await api.post("/v1/employee/getGeneralInformation", params);
};

export const compressedImage = async (params = {}) => {
    return await apiFormData.post(
        "/v1/image/compressedImage",
        params,
        {
            responseType: 'blob'
        }
    );
};

export const rejectExpenseRequestForCustomer = async (params={})=>{
    return await api.post("/v1/requestApprove/rejectFlowForCustomer",params)
}
export const rejectFlowForHr = async (params = {}) => {
    return await api.post("/v1/requestApprove/rejectFlowForHr", params);
  };